/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import NoteIcon from '@mui/icons-material/NoteAlt';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaidIcon from '@mui/icons-material/Paid';
import PushPinIcon from '@mui/icons-material/PushPin';
import Visibility from '@mui/icons-material/Visibility';
import Star from '@mui/icons-material/Star';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  CircularProgress,
  Avatar,
  ListItemSecondaryAction,
  ImageList,
  ImageListItem,
  Modal,
  Button,
  Paper,
  Grid,
} from '@mui/material';

import {
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  CloudDownload,
  UploadFile,
  WorkspacePremium,
} from '@mui/icons-material';
import {
  blueGrey,
  grey,
} from '@mui/material/colors';
import {
  getHorseFile,
  updateHorseNote,
  deleteHorseNote,
} from '../../../redux/horse/actions';

import Horse from '../../Horse';
import { formatDateString } from '../../../utils/dateHelper';
import {
  getColorHexForImportance,
  getNoteTypeDisplayName,
} from '../../../utils/enumHelper';
import HistoryActionsMenu from '../HistoryActionMenu';
import theme from '../../../utils/theme';

Divider

const isImage = /.png|jpeg|jpg|gif$/;

export const getIconForNoteType = (type, otherProps = {}) => {
  // Note, Medical, FeedChange, LocationChange, ProfileChange, Competition,
  if (type === 'ProfileChange') return <AssignmentIndIcon {...otherProps} />;
  if (type === 'FeedChange') return <RestaurantIcon {...otherProps} />;
  if (type === 'LocationChange') return <LocationOnIcon {...otherProps} />;
  if (type === 'Billing') return <PaidIcon {...otherProps} />;
  if (type === 'Medical') return <MedicalServicesIcon {...otherProps} />;
  if (type === 'Competition') return <WorkspacePremium {...otherProps} />;
  return <NoteIcon {...otherProps} />;
};

const NoteItemComponent = ({
  divider,
  note,
  horseId,
  pinnedHorseNoteId,
  isLoading,
  includeHorseInfo,
  hideActions,
  onEdit,
  hideNote,
  includeIcons,
  horsePublicShareId,
  hideChipLabel,
  hideNoteTypeChip,
  hideName,
  condensed,
}) => {
  const dispatch = useDispatch();

  const [downloadingFile, setDownloadingFile] = React.useState(null);
  const [download, setDownload] = React.useState(null);
  const [openPreview, setOpenPreview] = React.useState(null);

  const permissions = useSelector((state) => state.user.permissions);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const { horseNoteHighlights } = useSelector((state) => state.horse);

  const handleDownload = (file, skipBrowserDownload = false) => {
    setDownloadingFile(file);
    dispatch(getHorseFile(horseId, note.id, file, !skipBrowserDownload, horsePublicShareId)).then((blob) => {
      if (skipBrowserDownload) {
        setDownload(URL.createObjectURL(blob))
        setOpenPreview(file);
      }

      setDownloadingFile(null);
    }).catch((error) => {
      console.error(error);
      setDownloadingFile(null);
    });
  };

  const handleDeleteNote = (noteToDelete) => {
    if (pinnedHorseNoteId && pinnedHorseNoteId === noteToDelete.id) {
      // first remove the pin from the horse
      dispatch(updateHorseNote(horseId, noteToDelete.id, { setAsHorseActiveNote: false })).then(() => {
        dispatch(deleteHorseNote(horseId, noteToDelete.id));
      });
    } else {
      dispatch(deleteHorseNote(horseId, noteToDelete.id));
    }
  };

  const handlePinToHorse = (noteToPin) => {
    dispatch(updateHorseNote(horseId, noteToPin.id, { setAsHorseActiveNote: true }));
  };
  const handleUnpinToHorse = (noteToPin) => {
    dispatch(updateHorseNote(horseId, noteToPin.id, { setAsHorseActiveNote: false }));
  };

  const handleHighlightNote = (noteToHighlight) => {
    dispatch(updateHorseNote(horseId, noteToHighlight.id, {
      horseHighlight: horseNoteHighlights.length > 0
        ? (Math.max(...horseNoteHighlights.map((o) => o.highlightOrder)) + 1)
        : 1,
    }));
  }

  const handleUnHighlightNote = (noteToUnHighlight) => {
    dispatch(updateHorseNote(horseId, noteToUnHighlight.id, { removeHorseHighlightOrder: true }));
  }

  const pinnedToHorse = pinnedHorseNoteId && pinnedHorseNoteId === note.id
  const isHighlight = note.highlightOrder;

  const barnUser = (barnUsersMap[note.createdBy] || [{
    userFullName: note.createdBy.indexOf('System') >= 0
      ? 'Questri System'
      : 'Questri User',
  }])[0];

  return (
    <ListItem
      divider={divider}
      alignItems="flex-start"
      dense
      sx={{ paddingLeft: 0 }}
    >

      {!hideChipLabel && (
        <ListItemAvatar>
          <Avatar alt={getNoteTypeDisplayName(note.type)} sx={{ backgroundColor: getColorHexForImportance(note.importance, theme) }}>
            {getIconForNoteType(note.type, { sx: { color: 'white' } })}
          </Avatar>
        </ListItemAvatar>
      )}
      <ListItemText
        primaryTypographyProps={{
          sx: {
            flex: 1,
            width: '100%',
          },
          component: 'div',
        }}
        primary={(
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 2,
              width: '100%',
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                flex: 1,
              }}
            >
              {includeIcons && pinnedToHorse && (<PushPinIcon fontSize="medium" color="primary" />)}
              <Typography
                variant="h5"
                sx={{
                  flex: 1,
                  fontSize: 20,
                  textWrap: 'auto',
                }}
              >{note.title}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                {includeIcons && isHighlight && (<Star fontSize="medium" color="primary" />)}
                {includeIcons && note.clientAccess && (
                  <Tooltip title="This note is viewable by clients with access to this horse"><Visibility fontSize="medium" color="primary" /></Tooltip>
                )}
                {
                  includeHorseInfo
                  && (
                    <Horse chip horse={note.horse} />
                  )
                }
                {
                  !hideNoteTypeChip && (
                    <Chip
                      size="small"
                      icon={getIconForNoteType(note.type, { color: 'secondary' })}
                      label={getNoteTypeDisplayName(note.type)}
                    />
                  )
                }
              </Box>
            </Box>
          </Box>
        )}
        secondaryTypographyProps={{
          sx: {
            flex: 1,
            width: '100%',
          },
          component: 'div',
        }}
        secondary={(
          <Box sx={{ mt: '2px' }}>
            {
              !hideNote && (
                <Typography
                  sx={{ textWrap: 'auto' }}
                >
                  {
                    !hideName && (
                      <Typography
                        variant="caption"
                        fontWeight={600}
                      >
                        {barnUser.userFullName}{' '}
                      </Typography>
                    )
                  }

                  {
                    !hideName && (
                      <Typography
                        variant="caption"
                      >
                        {formatDateString(note.createdTimestamp)}{' '}
                      </Typography>
                    )
                  }
                  {
                    (note.note)
                    && (
                      <Typography component="span">
                        {!hideName
                          ? '- '
                          : ''} {note.note}
                      </Typography>
                    )
                  }
                </Typography>
              )
            }
            {
              !hideNote
              && ((note.information && note.information.files && note.information.files.length > 0))
              && (
                !condensed
                  ? (
                    <ImageList
                      sx={{
                        width: '100%',
                        height: ((Math.ceil(note.information.files.length / (3))) * (150)),
                      }}
                      cols={3}
                      rowHeight={150}
                    >
                      {note.information.files.map((file) => (
                        <ImageListItem
                          key={`note-key-${note.id}-${file}`}
                          onClick={() => {
                            handleDownload(file, file.match(isImage))
                          }}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              opacity: '65%',
                              backgroundColor: blueGrey[100],
                            },
                          }}
                        >
                          {
                            (!!file.match(isImage) && note.information.filePreviews && note.information.filePreviews[file])
                              ? (
                                <img
                                  src={note.information.filePreviews[file]}
                                  loading="lazy"
                                  alt={file}
                                  style={{
                                    maxHeight: 150,
                                    height: 150,
                                    display: 'block',
                                    opacity: !downloadingFile === file
                                      ? '50%'
                                      : undefined,
                                  }}
                                />
                              )
                              : (

                                <Box
                                  sx={{
                                    height: '100%',
                                    width: '100%',
                                    backgroundColor: 'rgba(47, 72, 88, 0.08)',
                                    margin: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: 2,
                                  }}
                                >
                                  {downloadingFile === file
                                    ? <CircularProgress size={18} />
                                    : <CloudDownload />}
                                  <Chip
                                    icon={<UploadFile />}
                                    variant="outlined"
                                    sx={{ maxWidth: 200 }}
                                    label={file}
                                  />
                                </Box>
                              )
                          }
                        </ImageListItem>
                      ))}
                    </ImageList>
                  )
                  : (
                    <Grid container spacing={1} flexWrap="wrap">
                      {note.information.files.map((file) => (
                        <Grid item key={`note-key-${note.id}-${file}`}>
                          <Chip
                            onClick={() => {
                              handleDownload(file, file.match(isImage))
                            }}
                            icon={downloadingFile === file
                              ? <CircularProgress size={18} />
                              : <UploadFile />}
                            variant="outlined"
                            sx={{ maxWidth: 200 }}
                            label={file}
                            size="small"
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )

              )
            }
            <Modal
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': { backgroundcolor: 'red' },
                m: 2,
              }}
              open={!!openPreview}
              onClose={() => setOpenPreview(null)}
            >
              <Paper>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 2,
                    backgroundColor: grey[600],
                  }}
                >
                  <img
                    src={download}
                    alt={openPreview}
                    style={{
                      margin: 'auto',
                      maxWidth: '100%',
                      maxHeight: 'calc(100vh - 128px)',
                    }}
                  />
                </Box>
                <Divider />
                <Box
                  sx={{
                    p: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                  }}
                >
                  <Button variant="outlined" onClick={() => { handleDownload(openPreview); setOpenPreview(false) }} startIcon={<CloudDownload />}>Download</Button>
                  <Button variant="contained" color="primary" onClick={() => setOpenPreview(false)}>Close</Button>
                </Box>
              </Paper>
            </Modal>
          </Box>
        )}
      />

      {
        ((permissions.admin || permissions.owner) && !hideActions)
        && (
          <ListItemSecondaryAction sx={{ top: '24px' }}><HistoryActionsMenu
            isLoading={isLoading}
            isActiveHorseNote={pinnedHorseNoteId && pinnedHorseNoteId === note.id}
            isHighlight={!!(note.highlightOrder || note.highlightOrder === 0)}
            onHighlight={() => handleHighlightNote(note)}
            onUnHighlight={() => handleUnHighlightNote(note)}
            onDelete={() => handleDeleteNote(note)}
            onPin={() => handlePinToHorse(note)}
            onUnpin={() => handleUnpinToHorse(note)}
            onEdit={() => onEdit(note)}
          />
          </ListItemSecondaryAction>
        )
      }
    </ListItem>
  );
};

NoteItemComponent.propTypes = {
  divider: PropTypes.bool,
  note: PropTypes.object,
  horseId: PropTypes.string.isRequired,
  pinnedHorseNoteId: PropTypes.string,
  isLoading: PropTypes.bool,
  includeHorseInfo: PropTypes.bool,
  includeIcons: PropTypes.bool,
  onEdit: PropTypes.func,
  hideActions: PropTypes.bool,
  hideNote: PropTypes.bool,
  horsePublicShareId: PropTypes.string,
  hideNoteTypeChip: PropTypes.bool,
  hideChipLabel: PropTypes.bool,
  condensed: PropTypes.bool,
  hideName: PropTypes.bool,
};

NoteItemComponent.defaultProps = {
  divider: true,
  note: {
    horse: {},
    note: '',
  },
  pinnedHorseNoteId: null,
  isLoading: false,
  includeHorseInfo: false,
  includeIcons: true,
  onEdit: () => { },
  hideActions: false,
  hideNote: false,
  horsePublicShareId: null,
  hideNoteTypeChip: false,
  hideChipLabel: false,
  hideName: false,
  condensed: false,
};

export default NoteItemComponent;
